import type { UserRoleType } from '@app/icare/entities/user/schema/User'

export type RoleKey = UserRoleType // 'CARE_Aussendienst' | 'CARE_Innendienst' | 'CARE_Teamleitung'
export type ModuleKey = 'iCare' // PROVISIONAL single module — split when licensing exists
export const ALL_MODULES: readonly ModuleKey[] = ['iCare']

const stringArray = (s: unknown, key: string): string[] => {
  if (s && typeof s === 'object' && key in s) {
    const value = (s as Record<string, unknown>)[key]
    if (Array.isArray(value)) return value as string[]
  }
  return []
}

const sessionData = (session: unknown): unknown => {
  if (session && typeof session === 'object' && 'session' in session) {
    return (session as { session?: unknown }).session
  }
  return undefined
}

export interface RoleSet {
  readonly list: readonly string[]
  has: (role: RoleKey) => boolean
  hasAnyOf: (...roles: RoleKey[]) => boolean
  hasAllOf: (...roles: RoleKey[]) => boolean
  only: (role: RoleKey) => boolean // exactly this one role (subsumes the old soleAD)
}

export const rolesOf = (session?: unknown): RoleSet => {
  const list = stringArray(sessionData(session), 'roles')
  const set = new Set(list)
  const has = (role: RoleKey) => set.has(role)
  return {
    list,
    has,
    hasAnyOf: (...roles) => roles.some(has),
    hasAllOf: (...roles) => roles.every(has),
    only: role => list.length === 1 && list[0] === role,
  }
}

export interface ModuleSet {
  readonly list: readonly ModuleKey[]
  has: (m: ModuleKey) => boolean
  hasAnyOf: (...m: ModuleKey[]) => boolean
}

export const modulesOf = (session?: unknown): ModuleSet => {
  const list = stringArray(sessionData(session), 'modules') as ModuleKey[] // absent → [] (default-deny)
  const set = new Set(list)
  const has = (m: ModuleKey) => set.has(m)
  return { list, has, hasAnyOf: (...modules) => modules.some(has) }
}
